import api from "@/services/api";

const { get, post } = api.getPrefixedMethods("templates");

export const templateService = {
  getTemplates({
    clientCompanyId,
    templateTypes,
    intakeOrderId,
    intakeDocumentKey,
    orderInfoKey,
    orderFormId,
    insuranceCardId,
  } = {}) {
    const params = {
      client_company_id: clientCompanyId,
      context_intake_order_id: intakeOrderId,
      context_intake_document_key: intakeDocumentKey,
      context_order_info_key: orderInfoKey,
      context_order_form_id: orderFormId,
      context_insurance_card_id: insuranceCardId,
    };

    // Only include template_types if the array is not empty
    if (templateTypes && templateTypes.length > 0) {
      params.template_types = templateTypes.join(",");
    }

    return get("", { params });
  },
  getTemplatePreview(templateId, content) {
    return get(`${templateId}/preview/`, {
      params: {
        content: content,
      },
    });
  },
  getFaxContent(requestData) {
    return post(`fax-content/`, requestData, {
      responseType: "text",
      _skipPropsAdaptation: true,
    });
  },
};
